import { QueryKey } from '../../enums/QueryKey';
import { getScenarioMinutePriceValues } from '../../services/budgetScenarioMinutePriceValues';
import { createScenarioQuery } from './budgetScenarios';

export const useScenarioMinutePriceValues = createScenarioQuery(
    QueryKey.BudgetScenarioMinutePriceValues,
    getScenarioMinutePriceValues
);
